/** Sample datasets for AB Test Calculator demo */

export const SAMPLE_POST_TEST = {
  variants: [
    { name: 'Control', sessions: '10000', conversions: '500', isControl: true },
    { name: 'Variant A', sessions: '10000', conversions: '650', isControl: false },
    { name: 'Variant B', sessions: '10000', conversions: '520', isControl: false },
  ],
  settings: {
    analysisMethod: 'bayesian',
    confidenceLevel: 0.95,
    testDuration: 21,
    dailyTraffic: 5000,
    trafficSplit: 50,
    averageOrderValue: 350,
  },
};

export const SAMPLE_PRE_TEST = {
  baselineRate: 5,
  minDetectableEffect: 15,
  alpha: 0.05,
  power: 0.8,
  dailyTraffic: 5000,
  trafficSplit: 50,
};

/** True when no sessions/conversions entered yet */
export const isPostTestFormEmpty = (variants) =>
  variants.every((v) => !String(v.sessions).trim() && !String(v.conversions).trim());

/** Pre-test uses numeric defaults — treat as empty until user runs first calculation */
export const isPreTestFresh = (preTestResults) => !preTestResults;
